/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
import Phaser from 'phaser';
import EDC from './globals';
import Button from './button';
import CursorManager from '@/components/games/shared/cursor-manager';

/**
 *
 */
EDC.Preloaders.QuickPanel = function (scene) {
  scene.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/quick-panel/');
  scene.load.setPrefix('quick-panel-');

  scene.load.image('btn-show-panel-normal', 'show-normal.png');
  scene.load.image('btn-show-panel-hover', 'show-over.png');

  scene.load.image('background-left', 'background-left.png');
  scene.load.image('background-left-hover', 'background-left-hover.png');
  scene.load.image('background-center', 'background-center.png');
  scene.load.image('background-center-hover', 'background-center-hover.png');
  scene.load.image('background-right', 'background-right.png');
  scene.load.image('background-right-hover', 'background-right-hover.png');

  scene.load.image('about-icon', 'buttons/about-icon.png');
  scene.load.image('about-label', 'buttons/about-label.png');
  scene.load.image('home-icon', 'buttons/home-icon.png');
  scene.load.image('home-label', 'buttons/home-label.png');
  scene.load.image('restart-icon', 'buttons/restart-icon.png');
  scene.load.image('restart-label', 'buttons/restart-label.png');

  scene.load.setPath();
  scene.load.setPrefix();
};

/**
 *
 */
EDC.UI.QuickPanel = function (scene) {
  this.scene = scene;
  this.showButton = null;
  this.isOpened = false;
  this.isMoving = false;

  this.prefix = 'quick-panel-';

  this.baseX = scene.game.scale.width;
  this.sx = this.baseX;
  this.sy = 100;

  this.stepBetweenButtons = 10;

  this.buttons = [];

  return this;
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.create = function () {
  this.cursorManager = new CursorManager(this.scene.game.canvas);
  this.showButton = new Button(this.scene, this.baseX, this.sy).create(
    'quick-panel-btn-show-panel-normal',
    'quick-panel-btn-show-panel-hover',
  );
  const size = this.showButton.getSize();
  this.btnHalfWidth = size.width / 2;
  this.sx -= this.btnHalfWidth;
  this.sy = size.height / 2;
  this.showButton.setPosition(this.sx, this.sy);
  this.showButton.setClickCallback(this.showOrHide.bind(this));

  const btnContainer = this.showButton.getContainer();
  this.cursorManager.setDefaultDraggableEvents(btnContainer);

  this.addPanelButtons();

  return this;
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.showOrHide = function () {
  if (this.isMoving) return;

  this.isMoving = true;

  // show buttons
  this.buttons.forEach((elem, index) => {
    this.scene.tweens.add({
      targets: elem,
      x: !this.isOpened ? elem.getData('showX') : elem.getData('hideX'),
      duration: 300,
      ease: !this.isOpened ? 'Back.easeOut' : 'Back.easeIn',
      onCompleteParams: [index, this.buttons.length],
      onComplete: (tween, targets, elemIndex, length) => {
        if (elemIndex === length - 1) this.isMoving = false;
      },
    });
  });

  this.isOpened = !this.isOpened;
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.addPanelButtons = function () {
  const size = this.showButton.getSize();
  let startY = size.height + this.stepBetweenButtons;

  startY += this.addButton('about', startY, this.onAbout);
  startY += this.addButton('home', startY, this.onHome);
  startY += this.addButton('restart', startY, this.onRestart);

  this.buttons.forEach((elem) => {
    elem.x = elem.getData('hideX');
  });
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.onAbout = function () {
  console.log('In-game ABOUT');
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.onHome = function () {
  console.log('In-game HOME');
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.onRestart = function () {
  console.log('in-game RESTART');
};
/**
 *
 */
EDC.UI.QuickPanel.prototype.addButton = function (type, y, callback) {
  const container = this.scene.add.container();
  const label = this.scene.add.sprite(0, 0, `${this.prefix + type}-label`);
  const icon = this.scene.add.sprite(0, 0, `${this.prefix + type}-icon`);

  const width = icon.width + label.width;
  const offset = 10;
  const extendedWidth = width + offset * 2;

  const left = this.scene.add.sprite(0, 0, `${this.prefix}background-left`);
  const leftHover = this.scene.add.sprite(0, 0, `${this.prefix}background-left-hover`);

  const right = this.scene.add.sprite(0, 0, `${this.prefix}background-right`);
  const rightHover = this.scene.add.sprite(0, 0, `${this.prefix}background-right-hover`);

  const neededCenterWidth = extendedWidth - (left.width + right.width);

  const center = this.scene.add.tileSprite(0, 0, neededCenterWidth, left.height, `${this.prefix}background-center`);
  const centerHover = this.scene.add.tileSprite(
    0,
    0,
    neededCenterWidth,
    left.height,
    `${this.prefix}background-center-hover`,
  );

  left.setPosition(left.displayWidth / 2, left.displayHeight / 2);
  leftHover.setPosition(left.x, left.y);
  leftHover.setAlpha(0);

  center.setPosition(left.x + left.displayWidth / 2 + center.width / 2, center.displayHeight / 2);
  centerHover.setPosition(center.x, center.y);
  centerHover.setAlpha(0);

  right.setPosition(center.x + center.width / 2 + right.displayWidth / 2, right.displayHeight / 2);
  rightHover.setPosition(right.x, right.y);
  rightHover.setAlpha(0);

  label.setPosition(offset + label.displayWidth / 2, center.y);
  icon.setPosition(label.x + label.displayWidth / 2 + icon.displayWidth / 2, center.y);

  container.add([left, center, right, leftHover, centerHover, rightHover, label, icon]);
  const bounds = container.getBounds();
  container.setPosition(this.baseX - bounds.width, y);
  container.setData('showX', container.x);
  container.setData('hideX', this.scene.scale.width);
  container.setInteractive(
    new Phaser.Geom.Rectangle(0, 0, bounds.width, bounds.height),
    Phaser.Geom.Rectangle.Contains,
  );
  container.on('pointerup', callback, this);
  container.on(
    'pointerover',
    () => {
      this.scene.tweens.add({
        targets: [leftHover, centerHover, rightHover],
        alpha: 1,
        duration: 100,
      });
    },
    this,
  );
  container.on(
    'pointerout',
    () => {
      this.scene.tweens.add({
        targets: [leftHover, centerHover, rightHover],
        alpha: 0,
        duration: 100,
      });
    },
    this,
  );
  this.buttons.push(container);

  this.cursorManager.setDefaultDraggableEvents(container);

  return bounds.height + this.stepBetweenButtons;
};

const exportPreloader = EDC.Preloaders.QuickPanel;
const exportQuickPanel = EDC.UI.QuickPanel;

export { exportQuickPanel as QuickPanel, exportPreloader as QuickPanelPreloader };
